import produce from 'immer';

// TYPES
import { Types, AtualizarMotivo } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: AtualizarMotivo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarMotivo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_MOTIVO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.ATUALIZAR_MOTIVO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_MOTIVO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_MOTIVO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
